import { useParams } from 'react-router';

import { Period } from '~/services/types';
import { usePeriodListAllQuery } from '~/services/period';
import { findStudentBySlug } from './routing';

export function useActiveStudentContext() {
  const { periodShortName, studentSlug } = useParams();
  const { data } = usePeriodListAllQuery();
  const periods = data?.periods;

  const activePeriod = periods?.find((p: Period) => p.shortName === periodShortName);
  const student =
    activePeriod?.students && studentSlug ? findStudentBySlug(activePeriod.students, studentSlug) : undefined;

  return {
    student,
    studentId: student?.id ?? '',
    activePeriod,
    periodId: activePeriod?.id ?? '',
    periodCreatedAt: activePeriod?.createdAt ?? '',
  };
}
